import { CKEditor } from '@ckeditor/ckeditor5-react'
import React, { useEffect, useState } from 'react'
import Editor from 'ckeditor5-custom-build/build/ckeditor'

import { MyUploadAdapter } from './MyUploadAdapter'
import './RichEditor.scss'

const toolbar = [
  'insertTable',
  'Alignment',
  'Autoformat',
  'AutoLink',
  'BlockQuote',
  'Bold',
  'Essentials',
  'FontBackgroundColor',
  'FontColor',
  'FontFamily',
  'FontSize',
  'Heading',
  'Image',
  'ImageInsert',
  'ImageResize',
  'ImageStyle',
  'ImageToolbar',
  'ImageUpload',
  'Indent',
  'IndentBlock',
  'Italic',
  'Link',
  'List',
  'ListStyle',
  'MediaEmbed',
  'MediaEmbedToolbar',
  'Mention',
  'Paragraph',
  'PasteFromOffice',
  'Strikethrough',
  'Table',
  'TableCellProperties',
  'TableProperties',
  'TableToolbar',
  'TextTransformation',
  'TodoList',
  'Underline',
  'WordCount',
]

const RichEditor = props => {
  const { EDITOR_REF, setData, placeholder, height, editorContent } = props
  const [editorState, setEditorState] = useState(null)

  useEffect(() => {
    if (editorState) {
      const editor = editorState
      editor.plugins.get('FileRepository').createUploadAdapter = function (
        loader
      ) {
        return new MyUploadAdapter(loader)
      }

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        )

      editor.editing.view.change(writer => {
        writer.setStyle(
          'height',
          height ?? '200px',
          editor.editing.view.document.getRoot()
        )
      })
    }
  }, [editorState, height])

  return (
    <CKEditor
      ref={EDITOR_REF}
      editor={Editor}
      config={{
        toolbar: toolbar,
        placeholder: placeholder ?? '',
        link: {
          addTargetToExternalLinks: true,
        },
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
            'tableProperties',
            'tableCellProperties',
          ],
        },
      }}
      onReady={editor => {
        // Connect the upload adapter using code below
        editor.plugins.get('FileRepository').createUploadAdapter = function (
          loader
        ) {
          return new MyUploadAdapter(loader)
        }

        editor.ui
          .getEditableElement()
          .parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
          )

        editor.editing.view.change(writer => {
          writer.setStyle(
            'height',
            '200px',
            editor.editing.view.document.getRoot()
          )
        })

        setEditorState(editor)
      }}
      onChange={(event, editor) => {
        const data = editor.getData()
        setData(data)
      }}
      data={editorContent}
    />
  )
}

export default RichEditor
